window.$ = window.jQuery = require('jquery')

require('bootstrap')
require('bootstrap/dist/css/bootstrap.css')

require('../../../vendor/mason.min.js')

require('../css/style.scss')
